<template>
  <div class="p-0 border-0" :class="{ 'avr-card': cardStyle, active: isActive, inactive: !isActive }">
    <slot name="header"></slot>
    <div>
      <div class="label" @click="isOpen = !isOpen" data-test="dropdownToggle" :class="labelClasses">
        <slot name="label"></slot>
        <img class="chevron" :class="{ 'is-open': isOpen }" src="@/assets/fa/chevron-down.svg" alt="" />
      </div>
      <div class="dropdown-section" data-test="dropdownSection" :class="{ 'is-open': isOpen }">
        <slot name="dropdown"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropDownCardV2',
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    labelClasses: {
      type: String,
      required: false,
    },
    defaultOpen: {
      type: Boolean,
      required: false,
    },
    cardStyle: {
      type: Boolean,
      default: true,
    },
    mobileOnly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.defaultOpen) {
      this.isOpen = true;
    }
  },
  computed: {
    isActive() {
      return !this.mobileOnly || (this.mobileOnly && this.isMobileScreenSize);
    },
  },
  methods: {
    setDropdownIsOpen(value) {
      this.isOpen = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.avr-card {
  overflow: hidden;
}
.inactive {
  .label {
    img {
      display: none;
    }
  }
}
.active {
  .label {
    position: relative;
    background-color: #ffffff;
    cursor: pointer;
    img {
      position: absolute;
      display: block;
      width: 24px;
      height: 15px;
      right: 15px;
      top: 50%;
      margin-top: -8px;
      transition: all 0.4s ease;
      &.is-open {
        transform: rotate(-180deg);
      }
    }
  }
  .dropdown-section {
    transition: all 0.5s ease;
    opacity: 0;
    max-height: 0;
    &.is-open {
      opacity: 1;
      max-height: 3000px;
    }
  }
}
</style>
